<template>
  <div class="step-title-container">
    <span>{{ step }}/{{ steps }}</span>
    <div>
      <span>{{ title }}</span>
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'StepTitle',
  computed: {
    ...mapState([
      'step',
      'steps'
    ]),
    title () {
      const stepTitleDict = {
        1: 'Wybierz najlepszy pakiet dla siebie',
        2: 'Wybierz długość planu',
        3: 'Wybierz dodatki',
        4: 'Podsumowanie'
      }
      return stepTitleDict[this.$store.state.step]
    },
    text () {
      const stepTextDict = {
        1: 'W tym kroku wybierasz rodzaj planu dla Twojego pakietu Kcalmar.pro',
        2: '',
        3: 'Możliwy wybór kilku dodatków.',
        4: ''
      }
      return stepTextDict[this.$store.state.step]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* TODO CR https://vuejs.org/v2/style-guide/#Element-selectors-with-scoped-use-with-caution */
.step-title-container > span{
  color: #ddd;
  font-family: 'Roboto-Medium';
  font-size: 88px;
  font-weight: bold;
}
.step-title-container > div{
  display: inline-block;
  left: 110px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.step-title-container > div > span:nth-child(1){
  display: block;
  font-size: 35px;
  font-weight: 300;
  text-transform: uppercase;
  vertical-align: top;
}
.step-title-container > div > span:nth-child(2){
  color: #4A4A4A;
  display: block;
  font-size: 15px;
  line-height: 30px;
  vertical-align: top;
}
.step-title-container{
  margin-bottom: 0;
  overflow: visible;
  position: relative;
}
@media screen and (max-width: 900px) {
  .step-title-container > div{
    display: inline-block;
    position: absolute;
    top: calc(50% + 10px);
  }
  .step-title-container{
    margin-bottom: 50px;
  }
}
</style>
